import {Validator, AbstractControl, NG_VALIDATORS } from "@angular/forms";
import {Directive, Input} from "@angular/core"

@Directive({
  selector:'[maxPasswordAgeValidtor]',
  providers:[
    {
      provide:NG_VALIDATORS,
      useExisting:MaxPasswordAgeValidtor,
      multi:true
    }
  ]
})
export class MaxPasswordAgeValidtor implements Validator{
    @Input() maxPasswordAgeValidtor:string
    validate(control:AbstractControl):null|{[key:string]:any}{
      const otherControl=control.parent.get(this.maxPasswordAgeValidtor)
      if(otherControl.value>control.value)
      return {
        maxPasswordAgeError:true
      }
      return null
    }
}
